import type { FieldConfig } from './lease-details.config';

// Readonly fields seed `field.value` (so submit payloads include the displayed
// value); everything else falls back to `defaultValue ?? null`.
export const collectFieldDefaults = (
  fields: Record<string, FieldConfig>,
): Record<string, unknown> => {
  const defaults: Record<string, unknown> = {};
  for (const [name, field] of Object.entries(fields)) {
    defaults[name] = field.kind === 'text-readonly' ? field.value : (field.defaultValue ?? null);
  }
  return defaults;
};
